module.exports = __webpack_public_path__ + "assets/img/2.012a8a21.png";